var config = require('../config/settings.json');

import Vue from 'vue';
import Tools from "../store/tools.js";
import storage from "../storage/data.js";

export default {
    login(context, credentials, callback) {
      context.$root.$emit('loading', true);
      context.$http.post(config.api_url + "users/login", credentials).then((response) => {
          var rep = {session:response.data};
          Vue.http.headers.common['Authorization'] = response.data.id;
          context.$http.get(config.api_url + "users/"+response.data.userId).then((resp) => {
              rep["user"] = resp.data;
              context.$root.$emit('loading', false);
              callback(rep, null);
          }, (resp) => {
              context.$root.$emit('loading', false);
              callback(null, Tools.translate(resp.data));
          });
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(null, Tools.translate(response.data));
      });
    },
    verifyPassword(context,credentials,callback){
      context.$root.$emit('loading', true);
      context.$http.post(config.api_url + "users/login", credentials).then((response) => {
          context.$root.$emit('loading', false);
          callback(true);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(false);
      });
    },
    changePassword(context,credentials,callback){
      // credentials = oldPassword & newPassword
      context.$root.$emit('loading', true);
      context.$http.post(config.api_url + "users/change-password", credentials).then((response) => {
          context.$root.$emit('loading', false);
          callback(null);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(Tools.translate(response.data));
      });
    },
    reset(context,email,callback){
      context.$root.$emit('loading', true);
      var data = {email:email};
      context.$http.post(config.api_url + "users/reset", data).then((response) => {
          context.$root.$emit('loading', false);
          callback(response.data);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(Tools.translate(response.data));
      });
    },
    resetPassword(context,newPassword,token,callback){
      context.$root.$emit('loading', true);
      var data = {newPassword:newPassword};
      Vue.http.headers.common['Authorization'] = token;
      context.$http.post(config.api_url + "users/reset-password", data).then((response) => {
          context.$root.$emit('loading', false);
          callback(response.data);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(Tools.translate(response.data));
      });
    },
    updateById(context,id,data,callback){
      context.$root.$emit('loading', true);
      context.$http.patch(config.api_url + "users/"+id, data).then((response) => {
          context.$root.$emit('loading', false);
          callback(response.data,null);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(null,response.data);
      });
    },
    getAll(context, callback) {
      context.$root.$emit('loading', true);
      context.$http.get(config.api_url + "users").then((response) => {
          callback(response.data,null);
          context.$root.$emit('loading', false);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(null, Tools.translate(response.data));
      });
    },
    getById(context, id, callback){
      context.$root.$emit('loading', true);
      context.$http.get(config.api_url + "users/"+id).then((response) => {
          callback(response.data,null);
          context.$root.$emit('loading', false);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(null, Tools.translate(response.data));
      });
    },
    create(context, user, callback){
      context.$root.$emit('loading', true);
      context.$http.post(config.api_url + "users",user).then((response) => {
          callback(response.data,null);
          context.$root.$emit('loading', false);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(null, Tools.translate(response.data));
      });
    },
    updateById(context, id, user, callback){
      context.$root.$emit('loading', true);
      context.$http.patch(config.api_url + "users/"+id,user).then((response) => {
          callback(response.data,null);
          context.$root.$emit('loading', false);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(null, Tools.translate(response.data));
      });
    },
    getGroups(context,callback){
      context.$root.$emit('loading', true);
      context.$http.get(config.api_url + "users/"+storage.data.session.userId+"/groups").then((response) => {
          callback(response.data,null);
          context.$root.$emit('loading', false);
      }, (response) => {
          context.$root.$emit('loading', false);
          callback(null, Tools.translate(response.data));
      });
    },
    updateToken(context,newTTL,callback){
      var data = {ttl:newTTL};
      context.$http.put(config.api_url + "users/"+storage.data.session.userId+"/accessTokens/"+storage.data.session.id,data).then((response) => {
          callback(response.data,null);
      }, (response) => {
          callback(null, Tools.translate(response.data));
      });
    }
}



// WEBPACK FOOTER //
// ./src/requests/users.js